import axios from "axios";
import myAppConfig from "../../config";

const getPageById = (pageId) => {
  return axios
    .get(`${myAppConfig.api.ENDPOINT}/api/v1/page/${pageId}`, { withCredentials: true })
    .then((response) => response);
};

const PageService = {
  getPageById,
};

export default PageService; 